import Generator from './generator';

export default class EnrolledPlannedCurveGenerator extends Generator {
  static _lineChartConfig = {
    yAxis: 1,
    type: 'line',
    dashStyle: null,
    showInLegend: true,
    enableMouseTracking: true,
    customTags: ['enrolled-planned'],
  };

  getEnrolledPlannedSeriesData(objectArray) {
    const seriesData = this._getSeriesData(objectArray, 'plannedEnrolledCum');

    return seriesData;
  }

  getSeries(objectArray) {
    const lineSeriesData = this.getEnrolledPlannedSeriesData(objectArray);

    const enrolledPlannedSeries = {
      id: 'enrolled-planned',
      name: 'Enrollment (Current plan)',
      data: lineSeriesData,
      color: '#FF03AF',
      zIndex: 3,
      marker: { enabled: lineSeriesData.length === 1 },
      ...EnrolledPlannedCurveGenerator._lineChartConfig,
    };

    return [enrolledPlannedSeries];
  }
}
